/**
 * Rules used by HttpErrorInterceptor to detect requests that update a main record
 * in admin/edit. For these we skip the interceptor modal so the manage component can
 * show a single modal with only the API detail (e.g. "All required fields are not filled.").
 */

/** HTTP methods that are treated as "record update" for skipping the interceptor modal. */
export const recordUpdateHttpMethods: string[] = ['PUT'];

export interface RecordUpdatePutRule {
  /** URL must contain this substring (e.g. 'microcredentials/' or '/programmes/') */
  pathContains: string;
  /** URL must also contain this (optional). e.g. 'verno=' for micro-credentials */
  pathAlsoContains?: string;
  /** URL must NOT contain any of these substrings */
  pathExcludes?: string[];
}

export const recordUpdatePutRules: RecordUpdatePutRule[] = [
  { pathContains: 'microcredentials/', pathAlsoContains: 'verno=' },
  { pathContains: '/programmes/', pathExcludes: ['/status'] },
  { pathContains: '/programmes/', pathAlsoContains: '/status' },
  {
    pathContains: '/qualifications/',
    pathExcludes: ['/status', '/translation', '/funding', '/logo']
  },
  { pathContains: '/standards/', pathExcludes: ['/status', '/expiring'] },
  { pathContains: '/cmrs/', pathExcludes: ['/status'] }
];
